<template>
  <el-card>
    <el-row :gutter="12">
      <el-col
        ><el-divider content-position="left">当前期: {{ shareBonusInfo.shareDateRange }}</el-divider></el-col
      >
      <el-col>
        <el-alert
          title="注：联创需满足三条安置线的报单和复销业绩之和各≥50盒，同理大区需≥100盒，董事需≥200盒 才能参与分红"
          type="warning"
          :closable="false"
        />
      </el-col>

      <el-col>
        <el-table style="width: 100%" :data="shareBonusInfo.userTeamPerformanceForBonusList">
          <el-table-column type="index" label="" />
          <el-table-column label="代理">
            <template slot-scope="scope">
              <!-- <span>{{ scope.row.real_name }}</span> -->
              <span>{{ scope.row.real_name }}({{ scope.row.level_name }})</span>
              <br />
              <span>{{ scope.row.username }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="team_complete_num" label="完成量" />
          <el-table-column label="完成情况">
            <template slot-scope="scope">
              <span v-if="scope.row.is_complete == 1" style="color:green;">完成</span>
              <span v-else style="color:red;">待完成</span>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
      <br />
    </el-row>

    <el-row :gutter="12">
      <el-col
        ><el-divider content-position="left">上一期: {{ shareBonusInfo.prevShareDateRange }}</el-divider></el-col
      >
      <el-col>
        <el-table style="width: 100%" :data="shareBonusInfo.saleProductStatListPrev">
          <el-table-column type="index" label="" />
          <el-table-column label="代理">
            <template slot-scope="scope">
              <span>{{ scope.row.real_name }}</span>
              <!-- <span>{{ scope.row.real_name }}({{ scope.row.level_name }})</span>
              <br />
              <span>{{ scope.row.username }}</span> -->
            </template>
          </el-table-column>
          <el-table-column prop="productNum" label="完成量" />
          <el-table-column label="完成情况">
            <template slot-scope="scope">
              <span v-if="scope.row.isComplete"><span style="color:green;">完成</span></span>
              <span v-else style="color:red;">未完成</span>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
      <br />
    </el-row>
  </el-card>
</template>

<script>
//
import { shareBonus } from '@/api/users'
export default {
  name: 'UserDetailShareBonus',
  components: {},
  props: {
    data: Object,
  },
  data() {
    return {
      shareBonusInfo: {},
    }
  },
  computed: {},
  watch: {
    $route: {
      async handler(newVal) {
        newVal.query.user_id = this.$route.params['id']
        const {
          data: { data },
        } = await shareBonus(newVal.query)
        console.log(data)
        this.shareBonusInfo = data
      },
      immediate: true,
    },
  },
}
</script>

<style></style>
